import { render, staticRenderFns } from "./PlugsCard.vue?vue&type=template&id=40b8b2bc"
import script from "./PlugsCard.vue?vue&type=script&lang=ts"
export * from "./PlugsCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports